module.exports = __webpack_public_path__ + "media/images/feedback-1055c1fd2a61f91c9342498841c58f80.svg";